import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { APICommonService } from '@nationwide/internet-servicing-angular-services';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GisResponse } from '../../tpi-models/general/gisResponse';
import { LoggerService } from '../logger/logger.service';
import { POLICY_REQUESTS_CONFIG, PolicyRequestsConfig } from '../../tokens/injection-tokens';

@Injectable({
    providedIn: 'root'
})
export class GisService {
    private apiCommonService = inject(APICommonService);
    private environment = inject<PolicyRequestsConfig>(POLICY_REQUESTS_CONFIG);
    private http = inject(HttpClient);
    private loggerService = inject(LoggerService);

    getPlace(fullAddress: string): Observable<GisResponse> {
        this.loggerService.info('Fetch address start - getPlace()', {
            fullAddress
        });
        fullAddress = fullAddress.split(' ').join('%20');
        const euaToken = sessionStorage.getItem('jwt');
        const headers = this.apiCommonService.buildHeader({
            appClientId: this.environment.authorize.client_id,
            authToken: euaToken,
            nwAppId: '',
            contentType: 'application/json',
            headerType: 'X-NW-Message-ID'
        });
        const url = `${this.environment.gisEndPoint}?apikey=${this.environment.authorize.client_id}&addressLimit=1&street=${fullAddress}`;
        return this.http.get<GisResponse>(url, { headers }).pipe(
            tap((gisResponse: GisResponse) => {
                this.loggerService.info('Fetch address End - getPlace()', {
                    gisResponse
                });
            })
        );
    }
}